import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timetableResults" }

import {
  computed,
  onMounted, ref, watch, watchEffect,
} from 'vue';
import {
  DatePickerCarousel,
  TimetableSearchResults,
  PortPairSailing,
  CarouselDateSelectionInfo,
  addDays,
} from '../../index';
import { useTimetableStore } from '../../stores';

const initialDaysToPreload = 7;


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableResultView',
  props: {
    from: {},
    to: {},
    fromDate: {},
    reinitDatepickerCarousel: { type: Boolean },
    isWebView: { type: Boolean }
  },
  emits: ['updateSearchResults', 'toggleSwiper', 'getSailingResults'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const timetableStore = useTimetableStore();
const sailings = ref<PortPairSailing[] | undefined>(timetableStore.getSailingResults);
const sailingAvailabilityByDate = ref<Record<string, boolean>>({});
const fromPort = ref('');
const toPort = ref('');

const isLoading = ref<boolean>(false);

const isError = computed(() => timetableStore.isServerError);

const fetchSailingAvailabilityForDateRange = async (
  startDate: string,
  endDate: string,
) => {
  const dates: string[] = [];
  const today = new Date().toISOString().split('T')[0];
  let currentDate = startDate.split('T')[0];
  const endDateOnly = endDate.split('T')[0];

  while (currentDate <= endDateOnly) {
    if (currentDate >= today) {
      dates.push(currentDate);
    }
    [currentDate] = addDays(currentDate, 1).split('T');
  }

  let datesToFetch = dates.filter((date) =>
    sailingAvailabilityByDate.value[date] === undefined);

  if (props.from !== fromPort.value || props.to !== toPort.value) {
    datesToFetch = dates;
  }

  const requests = datesToFetch.map(async (dateOnly) => {
    const result = await timetableStore.fetchSailingsForDate(
      props.from,
      props.to,
      dateOnly,
    );
    sailingAvailabilityByDate.value[dateOnly] = result.hasSailings;
  });
  await Promise.all(requests);
};

const getResults = async (newDate?: CarouselDateSelectionInfo) => {
  if (newDate) {
    emit('updateSearchResults', newDate.selectedDate);

    const startDate = addDays(newDate.selectedDate, -newDate.daysToLoad);
    const endDate = addDays(newDate.selectedDate, newDate.daysToLoad);
    await fetchSailingAvailabilityForDateRange(
      startDate,
      endDate,
    );
  }

  // if results have already been fetched for this date populate the sailings
  if (timetableStore.timetableSearchResults) {
    sailings.value = timetableStore.getSailingResults;
  }
};

onMounted(async () => {
  getResults();

  const startDate = addDays(props.fromDate, -initialDaysToPreload);
  const endDate = addDays(props.fromDate, initialDaysToPreload);
  await fetchSailingAvailabilityForDateRange(
    startDate,
    endDate,
  );
});

watchEffect(() => {
  isLoading.value = !!timetableStore.isLoading;
});

watch(() => timetableStore.getSailingResults, (results) => {
  if (results) {
    sailings.value = results;
    emit('getSailingResults', sailings.value);
  }
});

watch([() => props.from, () => props.to], async ([newFrom, newTo]) => {
  const startDate = addDays(props.fromDate, -initialDaysToPreload);
  const endDate = addDays(props.fromDate, initialDaysToPreload);
  await fetchSailingAvailabilityForDateRange(
    startDate,
    endDate,
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DatePickerCarousel), {
      "initial-date": _ctx.fromDate,
      "reinitialise-swiper": _ctx.reinitDatepickerCarousel,
      "sailing-availability": sailingAvailabilityByDate.value,
      onUpdateDate: _cache[0] || (_cache[0] = (newDate) => getResults(newDate)),
      onToggleInitSwiper: _cache[1] || (_cache[1] = (isInit) => _ctx.$emit('toggleSwiper', isInit))
    }, null, 8, ["initial-date", "reinitialise-swiper", "sailing-availability"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TimetableSearchResults), {
        sailings: sailings.value,
        "is-loading": isLoading.value,
        "is-error": isError.value
      }, null, 8, ["sailings", "is-loading", "is-error"])
    ])
  ], 64))
}
}

})